const trimTrailingSlash = (value: string): string => value.replace(/\/+$/, '');

const rawBaseUrl =
  import.meta.env.VITE_PUBLIC_PAYMENT_BASE_URL ||
  import.meta.env.VITE_PAYMENT_BASE_URL ||
  'https://payment.alexagolf.com';

export const PAYMENT_PUBLIC_BASE_URL = trimTrailingSlash(rawBaseUrl);
export const LEGACY_PAYMENT_HOSTNAME = 'payment.alexatur.com';
export const NEW_PAYMENT_HOSTNAME = 'payment.alexagolf.com';

export const buildPaymentUrl = (path: string): string => {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${PAYMENT_PUBLIC_BASE_URL}${normalizedPath}`;
};
